//src/components/common/Spinner.js
import { Box, CircularProgress } from "@mui/material";

const Spinner = () => (
  <Box
    sx={{
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      width: "100%",
      backgroundColor: "white",
    }}
  >
    <CircularProgress size={40} color="primary" />
  </Box>
);

export default Spinner;
